
import { Options, Vue } from 'vue-class-component';
import { eventBus } from '@/eventBus';

import Map from '@/components/UI/Map.vue';

import { getBaseDomain } from '@/requestManager';
import { ShootingPinPoint } from '@/classes/pages/shootingPin/ShootingPinPoint';

@Options({
  name: 'ShootingPinPlan',
  components: {
    Map,
  },

  props: {
    plans: Array,
    activePlanIndex: Number,
    mapPoints: Array as unknown as Array<ShootingPinPoint>,
    activePointId: Number,
  },
  data: () => ({
    activeFloorId: null,
    mapKey: null,
  }),
  computed: {
    activePlan() {
      return this.plans[this.activePlanIndex] || undefined;
    },
    tilesPath(): string {
      return `${getBaseDomain()}/img/plan/${ this.activePlan?.id }`;
    },
  },
  watch: {
    tilesPath() {
      this.updateMapKey();
    },
  },

  created() {
    this.initActiveFloorIdOrShowError();
    this.updateMapKey();

    eventBus.on('shooting-pin-page.point', this.updateMapKey);
  },
  beforeDestroy() {
    eventBus.off('shooting-pin-page.point', this.updateMapKey);
  },

  methods: {
    initActiveFloorIdOrShowError(): void {
      if (!this.plans?.length) {
        alert('Ошибка! Невозможно показать страницу, потому что не прикреплено ни одного плана');
        return;
      }

      this.activeFloorId = this.plans[0].id;
    },

    callToChangeActivePlanIndex(index: number): void {
      this.$emit('changeActivePlanIndex', index);
    },
    updateMapKey(): void {
      const timestamp = +(new Date());
      this.mapKey = `${timestamp}-${this.tilesPath}`;
    },
  },
})
export default class ShootingCreatePlan extends Vue {}
